import clsx from "clsx";
import React from "react";

import { useHeaderMenu } from "../../../../hooks/use-header-menu";
import { Icon } from "../../../icon";

export interface HeaderMenuItemDetailTitleProps {
  title: string;
  titleClassName?: string;
  className?: string;
}

export function HeaderMenuItemDetailTitle({
  title,
  titleClassName,
  className,
}: HeaderMenuItemDetailTitleProps) {
  const { setExpandedItemId } = useHeaderMenu();
  return (
    <div
      className={clsx("flex items-center gap-1 pb-1 cursor-pointer", className)}
      onClick={() => setExpandedItemId(null)}
    >
      <Icon icon="arrow-left" className="w-8" />
      {title && <h3 className={clsx("text-2xl", titleClassName)}>{title}</h3>}
    </div>
  );
}
